// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import inquiryStatusEntity from './entities/inquiry-status.json';
import inquiryStatusMenu from '../pages/inquiry-status/menu.json';
import inquiryStatusFullForm from '../pages/inquiry-status/forms/full.json';
import inquiryStatusContextForm from '../pages/inquiry-status/forms/context.json';
import inquiryStatusMiniForm from '../pages/inquiry-status/forms/mini.json';
import inquiryStatusLookupForm from '../pages/inquiry-status/forms/lookup.json';
import inquiryStatusTableView from '../pages/inquiry-status/views/table.json';
import inquiryStatusDashboardView from '../pages/inquiry-status/views/dashboard.json';

/** Тип запису «Статус запиту» зі сторінками пакета: меню, форми та подання з pages/inquiry-status/. */
export const inquiryStatusDefinition: IRecordTypeDefinition = {
  ...inquiryStatusEntity,
  views: assembleViewSet({
      table: inquiryStatusTableView,
      dashboard: inquiryStatusDashboardView,
  }),
  form: inquiryStatusFullForm,
  forms: { full: inquiryStatusFullForm, context: inquiryStatusContextForm, mini: inquiryStatusMiniForm, lookup: inquiryStatusLookupForm },
  menu: inquiryStatusMenu,
} as IRecordTypeDefinition;
